import { render, staticRenderFns } from "./InvestmentContactsRow.vue?vue&type=template&id=460f2146"
import script from "./InvestmentContactsRow.vue?vue&type=script&lang=js"
export * from "./InvestmentContactsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports